module.exports = __webpack_public_path__ + "static/media/inspector-dottie-welcome.b7fbf6f5.png";